import {BrowserModule} from '@angular/platform-browser';
import {DEFAULT_CURRENCY_CODE, ErrorHandler, NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';

import {LayoutModule} from './layout/layout.module';
import {MonitoringErrorHandler} from './shared/services/monitoring-error-handler';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {
    MSAL_GUARD_CONFIG,
    MSAL_INSTANCE,
    MSAL_INTERCEPTOR_CONFIG,
    MsalBroadcastService,
    MsalGuard,
    MsalGuardConfiguration,
    MsalInterceptor,
    MsalInterceptorConfiguration,
    MsalModule,
    MsalService,
    MsalRedirectComponent
} from '@azure/msal-angular';
import {InteractionType, IPublicClientApplication, PublicClientApplication} from '@azure/msal-browser';
import {ENV_CONFIG, EnvConfig} from '../configuration';

export function MSALInstanceFactory(envConfig: EnvConfig): IPublicClientApplication {
    return new PublicClientApplication({
        auth: {
            clientId: envConfig.msalConfig.clientId, // This is your client ID
            authority: envConfig.msalConfig.authority, // This is your tenant ID
            redirectUri: envConfig.msalConfig.redirectUri // This is your redirect URI
        },
        cache: {
            cacheLocation: 'localStorage',
            storeAuthStateInCookie: false
        }
    });
}

export function MSALInterceptorConfigFactory(envConfig: EnvConfig): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map([[envConfig.msalConfig.apiResourceUri, [envConfig.msalConfig.apiScope]]]);
    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap
    };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        authRequest: {
            scopes: ['user.read', 'profile']
        },
        loginFailedRoute: '/auth/should-login'
    };
}

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        LayoutModule,
        BrowserAnimationsModule,
        MatButtonModule,
        MatIconModule,
        MsalModule
    ],
    providers: [
        {provide: ErrorHandler, useClass: MonitoringErrorHandler},
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory,
            deps: [ENV_CONFIG]
        },
        {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MSALGuardConfigFactory,
            deps: [ENV_CONFIG]
        },
        {
            provide: MSAL_INTERCEPTOR_CONFIG,
            useFactory: MSALInterceptorConfigFactory,
            deps: [ENV_CONFIG]
        },
        {provide: DEFAULT_CURRENCY_CODE, useValue: 'USD'},
        MsalService,
        MsalGuard,
        MsalBroadcastService
    ],
    bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule {}
